





























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import PhaseCard from '@/components/Phases/PhaseCard.vue';
import { Phase } from '@/interfaces/Phase';

@Component({
  components: { PhaseCard }
})
export default class EditCutoverplanPhaseTab extends Vue {
  @Watch('phases')
  phasesUpdated() {
    this.phasesByEnv = {};
    this.phases?.forEach((phase) => {
      if (!this.phasesByEnv[phase.environment_id]) this.phasesByEnv[phase.environment_id] = [];
      this.phasesByEnv[phase.environment_id].push(phase);
    });
    this.updatePhasesByEnv = true;
    this.updatePhasesByEnv = false;
  }

  @Prop()
  cutoverplan?: any;

  @Prop()
  phases?: any[];

  @Prop()
  selectedEnvironment!: number;

  get environmentsForSelect() {
    return this.cutoverplan.environments?.map((environment: any) => ({
      text: environment.name,
      value: environment.id
    }));
  }

  get environmentsWithDefault() {
    const envs = [{ id: 'null', name: 'Default' }];
    if (this.cutoverplan?.environments?.length) {
      envs.push(...this.cutoverplan.environments);
    }
    return envs;
  }

  phasesByEnv: any = {};

  selectedEnvironmentId = -1;

  selectedPhase: any = {};

  updatePhasesByEnv = false;

  get addablePhases() {
    const allPhases = this.$store.state.all_phases;
    const filteredPhases = allPhases.filter(
      (phase: Phase) => !this.cutoverplan?.phases?.find((p: Phase) => p.id === phase.id)
    );
    return filteredPhases.map((phase: Phase) => {
      const preferredLanguage = phase.phaseLanguages?.find(
        (language: any) => language.languageId === this.$store.state.user.languageId
      );
      return {
        text: preferredLanguage?.name || phase.phaseLanguages?.[0]?.name,
        value: phase
      };
    });
  }

  addPhase() {
    this.phases?.push({
      environment_id: null,
      phase_id: this.selectedPhase.id,
      id: this.selectedPhase.id,
      name: this.selectedPhase.name,
      start: '',
      cutoverplan_id: this.cutoverplan.id
    });
  }

  removePhase(phase: any) {
    const index = this.phases?.indexOf(phase);
    if (index !== undefined && index > -1) {
      this.phases?.splice(index, 1);
    }
  }

  async created() {
    this.phases?.forEach((phase) => {
      if (!this.phasesByEnv[phase.environment_id]) this.phasesByEnv[phase.id] = [];
      this.phasesByEnv[phase.id].push(phase);
    });
  }
}
